// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__0MgjJ"};